import React from 'react';

import ContextualDataSVG from './contextualdata-icon';
import ImageSVG from './image-icon';
import DeleteSVG from './delete-icon';
import AlertSVG from './alert-icon';
import CloudSVG from './cloud-icon';
import CloseSVG from './close-icon';

const Icon = (props: any) => {
  switch (props.name) {
    case 'contextual-data':
      return <ContextualDataSVG {...props} />;
    case 'image':
      return <ImageSVG {...props} />;
    case 'delete':
      return <DeleteSVG {...props} />;
    case 'alert':
      return <AlertSVG {...props} />;
    case 'cloud':
      return <CloudSVG {...props} />;
    case 'close':
      return <CloseSVG {...props} />;
    default:
      return null;
  }
};

export default Icon;
